export default __webpack_public_path__ + "static/media/ISMO CLASS-3 EXAM PATTERN 2025.29266231.pdf";